import React from 'react';
import style from './style.module.less';

export const StatusConnector = () => {
  return <div className={style['history-connector']} />;
};
